import * as React from "react";
const SvgFiRrCloudSun = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-sun_svg__a)">
      <path
        fill="#062147"
        d="M13.892 24c-1.96 0-3.837-.008-4.491-.026a3.8 3.8 0 0 1-.834-.121 3.5 3.5 0 0 1-.449-6.588 6.4 6.4 0 0 1 .057-2.732 6 6 0 0 1 11.368-.855c.136.326.286.36.587.427l.176.042a5.014 5.014 0 0 1 3.559 6 4.95 4.95 0 0 1-3.7 3.7q-.526.12-1.064.131c-.872.012-3.088.022-5.209.022m.09-12.023q-.296 0-.589.043a3.993 3.993 0 0 0-3.306 4.78 2.02 2.02 0 0 1-1.18 2.3 1.494 1.494 0 0 0-.851 1.8 1.47 1.47 0 0 0 1.402 1.076c1.342.036 7.945.03 9.6 0q.332-.008.657-.081a2.98 2.98 0 0 0 2.2-2.193 3.023 3.023 0 0 0-2.132-3.622l-.092-.021a2.58 2.58 0 0 1-2-1.611 4.01 4.01 0 0 0-3.709-2.471M2.28 16.894a1 1 0 0 1-.512-1.86l2.709-1.612a.5.5 0 0 0 .3-.54 6.4 6.4 0 0 1-.2-.882H1a1 1 0 0 1 0-2h3.575c.074-.48.204-.95.387-1.4L1.884 6.8a1 1 0 1 1 1.01-1.725l3.1 1.814q.429-.514.951-.934L5.11 2.854a1 1 0 0 1 1.721-1.02l1.843 3.109A6.5 6.5 0 0 1 10 4.58V1a1 1 0 0 1 2 0v3.577c.475.074.94.204 1.384.386l1.823-3.115a1.001 1.001 0 0 1 1.727 1.011l-1.843 3.146c.427.274.717 1 1.27.717L19 4.972a1 1 0 1 1 1.1 1.668l-2.684 1.78a2.51 2.51 0 0 1-3.147-.442A4.7 4.7 0 0 0 10.986 6.5 4.69 4.69 0 0 0 6.5 11.023c-.004.433.06.864.191 1.277a2.46 2.46 0 0 1-1.231 2.863l-2.669 1.59a1 1 0 0 1-.511.141"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-sun_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudSun;
